import React from "react";
import { Spinner } from "react-bootstrap";
import { BsSearch, BsXCircle } from "react-icons/bs";

import ServicePicker from "../../../Common/Components/ServicePicker";
import LaundryItemCard from "../../../Common/Components/LaundryItemCard";
import { getBundleMessage } from "../../../Services/CartService";

const ServicePickerMemo = React.memo(ServicePicker);

const ItemsStep = ({
  initLoading,
  orderTypeId,
  bookingType,
  handleBookingTypeChange,
  payload,
  selectService,
  services,
  categories,
  selectCategory,
  search,
  setSearch,
  itemsLoading,
  fetchError,
  setReload,
  filteredItems,
  getLaundryItem,
  campaign,
  changeAddonQuantity,
  changeItemQuantity,
  toggleAddons,
  getOffer,
  changeItemNote,
  count,
  amount,
  setCShow,
}) => {
  return initLoading ? (
    <div className="text-center py-4"><Spinner variant="primary" /></div>
  ) : (
    <>
      {orderTypeId != 1 && orderTypeId != 2 ? (
        <div
          className="d-flex justify-content-center row-gap-3 column-gap-3"
          style={{ paddingTop: "10px" }}
        >
          <div>
            <div className="form-check">
              <input
                className="form-check-input"
                checked={bookingType == 1}
                id="regular-radio"
                onChange={(e) =>
                  handleBookingTypeChange(e.target.checked ? 1 : null)
                }
                type="radio"
              />
              <label className="form-check-label" htmlFor="regular-radio">
                Regular
              </label>
            </div>
          </div>
          <div>
            <div className="form-check">
              <input
                className="form-check-input"
                id="express-radio"
                checked={bookingType == 2}
                onChange={(e) =>
                  handleBookingTypeChange(e.target.checked ? 2 : null)
                }
                type="radio"
              />
              <label className="form-check-label" htmlFor="express-radio">
                Express
              </label>
            </div>
          </div>
        </div>
      ) : null}
      <div className="service-picker-fix mb-3">
        <ServicePickerMemo
          compactMobile
          payload={payload}
          selectService={selectService}
          services={services}
        />
      </div>
      <div className="text-center mb-3 consumer-category-title">
        <span className="fw-bold" style={{ fontSize: "16px", color: "#656565" }}>
          <span className="consumer-category-step-number">2. </span>Select Category
        </span>
      </div>
      <div
        className="d-flex gap-2 px-3 mb-3 overflow-auto justify-content-center consumer-category-strip"
        style={{ flexWrap: "nowrap" }}
      >
        {categories.map((cat) => (
          <div
            key={cat.id}
            className={`px-3 py-2 rounded-pill consumer-category-chip ${
              cat.id === payload.categoryId ? "bg-dark text-white" : "bg-light"
            }`}
            style={{ cursor: "pointer", whiteSpace: "nowrap", fontSize: "14px" }}
            onClick={() => selectCategory(cat.id)}
          >
            {cat.name}
          </div>
        ))}
      </div>

      <div className="row justify-content-center mb-3 consumer-item-search">
        <div className="col-lg-8 col-12">
          <div className="position-relative">
            <input
              type="text"
              className="form-control"
              placeholder="Search items..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ paddingLeft: "40px", height: "44px", borderRadius: "10px" }}
            />
            <BsSearch
              style={{
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            />
            {search && (
              <BsXCircle
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "14px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#999",
                }}
                onClick={() => setSearch("")}
              />
            )}
          </div>
        </div>
      </div>

      <div className="row px-2 laundry-items-fix consumer-item-list">
        {itemsLoading ? (
          <div className="col-12 text-center py-4"><Spinner variant="warning" /></div>
        ) : fetchError ? (
          <div className="col-12 text-center py-4">
            <p className="text-danger">Failed to load items.</p>
            <button className="btn consumer-order-primary" onClick={() => setReload(Date.now().toString())}>
              Retry
            </button>
          </div>
        ) : filteredItems.length === 0 ? (
          <div className="col-12 text-center py-4 text-muted">
            {search ? "No matching items" : "No items in this category"}
          </div>
        ) : (
          <div className="row">
            {filteredItems.map(({ item: e, originalIndex }) => (
              <div className="col-lg-6 col-12 mb-3" key={`${e.laundry_item_id}-${e.serviceId}`}>
                <LaundryItemCard
                  laundryItem={getLaundryItem(e.laundry_item_id)}
                  description={getLaundryItem(e.laundry_item_id)?.description}
                  campaign={campaign}
                  item={e}
                  itemIndex={originalIndex}
                  changeAddonQuantity={changeAddonQuantity}
                  changeItemQuantity={changeItemQuantity}
                  toggleAddons={toggleAddons}
                  offer={getOffer(e.laundry_item_id)}
                  bundleMessage={getBundleMessage(e)}
                  onNoteChange={(note) => changeItemNote(originalIndex, note)}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Total bar */}
      <div className="d-flex justify-content-between align-items-center px-3 py-3 bg-light rounded mt-2 consumer-items-total">
        <span className="fw-semibold">Total: {count} item{count !== 1 ? "s" : ""}</span>
        <span className="fw-bold text-primary fs-5">Rs. {amount?.toLocaleString()}</span>
      </div>
      {count > 0 && (
        <div className="d-flex justify-content-end mt-2">
          <button className="btn btn-sm btn-outline-danger" onClick={() => setCShow(true)}>
            Clear Cart
          </button>
        </div>
      )}
    </>
  );
};

export default ItemsStep;
